import React, { useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../../../SpaAndWellCommonStyles.module.scss';
import metadata from './AdditionalInformation.metadata.json5';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

const OPERATIONS_PATH_ARRAY = ['masRegFie', 'tanBedBooFie', 'lasTreFie', 'injSerFie', 'teaOpeFie', 'teewhiFie', 'plaRicPlaFie', 'plaFie']

function AdditionalInformation(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('AdditionalInformation');
    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;

    const initializeAddlInfo = () => {
        const cheTesDaiFieValue = _.get(modelVM, 'cheTesDaiFie.value') !== undefined
            ? _.get(modelVM, 'cheTesDaiFie.value') : "true";
        const areanycliundtheagef18FieValue = _.get(modelVM, 'areanycliundtheagef18Fie.value') !== undefined
            ? _.get(modelVM, 'areanycliundtheagef18Fie.value') : "false";


        _.set(modelVM, 'cheTesDaiFie.value', cheTesDaiFieValue);
        _.set(modelVM, 'areanycliundtheagef18Fie.value', areanycliundtheagef18FieValue);
    }

    useEffect(() => {
        initializeAddlInfo();
    }, []);

    const isNoneChecked = useCallback(() => {

        const currentNoneValue = _.get(submissionVM, `${pathUpdated}.nonFie.value`, true);

        const updatedNoneValue = !OPERATIONS_PATH_ARRAY.some(val => _.get(modelVM, `${val}.value`, false) === true);

        if (updatedNoneValue !== currentNoneValue) {
            _.set(submissionVM, `${pathUpdated}.nonFie.value`, updatedNoneValue);
            updateWizardData(submissionVM)
        }


    }, [modelVM, pathUpdated, submissionVM, updateWizardData])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        divBoaFie: {
            visible: _.get(modelVM, 'numofSwiPooFie.value') > 0,
            defaultValue: false
        },
        aretheanySliFie: {
            visible: _.get(modelVM, 'numofSwiPooFie.value') > 0,
            defaultValue: false
        },
        cheTesDaiFie: {
            visible: _.get(modelVM, 'numofSwiPooFie.value') > 0,
            defaultValue: false
        },
        isthealcsermortha1recFie: {
            visible: _.get(modelVM, 'doyoueveseralcaspaserFie.value')
        },
        ifyesPledescFie: {
            visible: _.get(modelVM, 'doyourenspatoassbubusFie.value')
        },
        ifyesPledeFie: {
            visible: _.get(modelVM, 'doyoubrianyspeintyopeFie.value')
        },
        ifyesPledesFie: {
            visible: _.get(modelVM, 'aretheanyopeoractapreFie.value')
        },
        ifyesplepronamofpruseFie: {
            visible: _.get(modelVM, 'doyouproanyperhaisopeFie.value')
        },
        areanycliundtheagef18Fie: {
            visible: _.get(modelVM, 'doyouevereuneeFie.value'),
            defaultvalue: false
        },
        minageofcliFie: {
            visible: _.get(modelVM, 'doyouevereuneeFie.value')
        },
        whaserareprototheiindFie: {
            visible: _.get(modelVM, 'doyouevereuneeFie.value')
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            if (OPERATIONS_PATH_ARRAY.includes(changedPath)) {
                isNoneChecked()
            }

            updateWizardData(submissionVM);
        },
        [isNoneChecked, pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            //onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

AdditionalInformation.propTypes = wizardProps;
export default withRouter(AdditionalInformation);
